import store from '@/store/store';
import siteConfig from '@/configurations/siteConfig';
import { LISTE_CATEGORIE_PANNEAU } from '@/configurations/configPanneau';
import { COULEURS_MARKER, AZIMUT } from './iconMarkerConf';

export const TAILLE_ICON_PLUS_GRAND = 70;
export const TAILLE_ICON_GRAND = 50;
export const TAILLE_ICON_PETIT = 38;
export const TAILLE_ICON_LARGEUR = 40;
export const TAILLE_ICON_HAUTEUR = 60;

const hauteurDuFichier = 2569;
const largeurDuFichier = 530;

function findAzimut(azimut) {
  const result = AZIMUT.find((option) => {
    return (azimut >= option.min && azimut <= option.max)
      || (option.min2 && azimut >= option.min2 && option.max2 && azimut <= option.max2);
  });
  if (result) return result.value;
  return 0;
}

export function iconColorGetter(colorDemande, tailleDemande, azimutDemande, afficherAzimut) {
  let color = LISTE_CATEGORIE_PANNEAU[0].couleur;
  if (colorDemande) color = colorDemande;
  let taille = tailleDemande;
  if (!taille) {
    taille = TAILLE_ICON_PETIT;
  }
  let azimut = azimutDemande;
  if (azimut === null || azimut === undefined || !afficherAzimut) {
    azimut = 'aucun';
  }
  azimut = findAzimut(azimut);
  const ratio = taille / TAILLE_ICON_HAUTEUR;
  return {
    url: require('@/assets/images/icon_marker/icons.png'),
    scaledSize: { width: largeurDuFichier * ratio, height: hauteurDuFichier * ratio, f: 'px', b: 'px' },
    size: { width: TAILLE_ICON_LARGEUR * ratio, height: taille, f: 'px', b: 'px' },
    origin: { x: azimut * TAILLE_ICON_LARGEUR * ratio, y: COULEURS_MARKER[color.toLowerCase()] * TAILLE_ICON_HAUTEUR * ratio, f: 'px', b: 'px' },
  };
}

function roundRect(context, x, y, w, radius, color) {
  const h = w;
  const r = x + w;
  const b = y + h;
  context.beginPath();
  context.strokeStyle= color ? color : "green";
  context.fillStyle=color;
  context.lineWidth="4";
  context.moveTo(x+radius, y);
  context.lineTo(r-radius, y);
  context.quadraticCurveTo(r, y, r, y+radius);
  context.lineTo(r, y+h-radius);
  context.quadraticCurveTo(r, b, r-radius, b);
  context.lineTo(x+radius, b);
  context.quadraticCurveTo(x, b, x, b-radius);
  context.lineTo(x, y+radius);
  context.quadraticCurveTo(x, y, x+radius, y);
  context.fill();
}

function drawBull (img, couleur, azimut, index) {
  const rayon = 12;  // Rayon du cercle contenant le numéro du panneau
  
  // Création d'un objet canvas
  const canvas = document.createElement('canvas');
  const width = TAILLE_ICON_LARGEUR + rayon;  // Définition de la largeur du canvas
  const height = TAILLE_ICON_HAUTEUR + rayon;  // Définition de la hauteur du canvas
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  // Position du marqueur dans le canvas
  const x = AZIMUT.find(az => az.azimut === azimut).value * TAILLE_ICON_LARGEUR;
  const y = COULEURS_MARKER[couleur.toLowerCase()] * TAILLE_ICON_HAUTEUR;

  // Dessin de l'image dans le canvas
  ctx.drawImage(img, x, y, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR, 0, rayon, TAILLE_ICON_LARGEUR, TAILLE_ICON_HAUTEUR);

  // Dessin du cercle qui contiendra le numéro du panneau
  ctx.beginPath();
  ctx.arc(TAILLE_ICON_LARGEUR, rayon + 5, rayon, 0, Math.PI * 2, true);
  ctx.fillStyle = '#2C3E50';
  ctx.fill();

  // Insertion du numéro du panneau
  ctx.font = 'bold 17px sans-serif';
  ctx.fillStyle = 'white';
  ctx.fillText(index, TAILLE_ICON_LARGEUR - (index<=9?5:10), rayon + 10);

  // Retour du canvas sous forme d'image png
  const dataURL = canvas.toDataURL('image/png');
  return dataURL;
}

export function iconPointDeVente(img, cote, color) {
  const site = store.getters['user/site'];
  const { pdvAnchorIcon } = (siteConfig[site] || siteConfig.default).pdv;
  const canvas = document.createElement('canvas');
  const width = cote - 5;
  const height = cote;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  const radius = 0;
  const coteCarre = width - 2 * radius;
  roundRect(ctx, radius, radius, coteCarre, radius, color);
  ctx.strokeStyle = color ? color: '';
  if (pdvAnchorIcon) {
    ctx.beginPath();
    ctx.moveTo(width / 2 - 6, width);
    ctx.lineTo(width / 2, height);
    ctx.lineTo(width / 2 + 6, height - (height - width));
    ctx.closePath();
    ctx.fill();
  }
  const border = 2;
  const widthImage = img.naturalWidth ? img.naturalWidth : cote;
  const heigthImage = img.naturalHeight ? img.naturalHeight : cote;
  ctx.drawImage(img, 0, 0, widthImage, heigthImage, border, border, width - border * 2, width - border * 2);
  return canvas.toDataURL('image/png');
}

export function iconMarkerInfoBulle(couleur, azimut, index) {
    return new Promise((resolve) => {
      // Récupération de l'image contenant toute les icônes
      const img = new Image(largeurDuFichier, hauteurDuFichier);
      img.src = require('@/assets/images/icon_marker/icons.png');
    
      img.onload = function () {
        const data = drawBull(img,couleur, azimut, index);
        resolve(data);
      }
    
     
    });
}

export async function getIconPdvData(url, width, height, color) {
  const site = store.getters['user/site'];
  const { widthIcon, colorIcon, getGoogleAnchor } = (siteConfig[site] || siteConfig.default).pdv;
  const w = width || widthIcon;
  const h = height || widthIcon;
  const c = color !== undefined ? color : colorIcon;
  return new Promise(resolve => {
    const img = document.createElement('img');
    img.onload = () => {
      const logo = iconPointDeVente(img, w, c);
      const icon = {
        url: logo,
        scaledSize: new google.maps.Size(w, h),
        origin: new google.maps.Point(0, 0),
        anchor: getGoogleAnchor(w, h),
      };
      resolve({
        icon,
        data: logo,
        width: img.width,
      });
    };
    img.onerror = () => {
      img.src = require('@/assets/images/default_img.png');
    };
    img.setAttribute('src', url);
    img.setAttribute('crossOrigin', 'Anonymous');
  })
}